<template>
  <footer
    :class=" [
      $style.footer,
      $style.condensed,
      {
        [$style.hasBanner]: !cookiesAccepted,
        [$style.mobileFlow]: isMobileScreen
      }
    ]"
  >
    <CookieBanner />
    <div :class="[$style.footerContent, $style.condensedContent]">
      <p :class="$style.copyrightText">
        Copyright All Rights Reserved © {{ new Date().getFullYear() }}
      </p>
      <ul
        :class="[$style.footerLinkContainer,$style.condensedLinkContainer]"
      >
        <li
          v-for="link in footerLinks"
          :key="link.label"
        >
          <a
            :class="['jc-link', $style.footerLink]"
            :href="link.href"
          >
            {{ link.label }}
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
import CookieBanner from 'client/signup/components/CookieBanner.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

export default {
  name: 'Footer',

  components: {
    CookieBanner,
  },

  data: () => ({
    KbArticleUrls,
    footerLinks: [
      {
        label: 'Support',
        href: 'https://jumpcloud.com/support',
      },
      {
        label: 'Privacy Policy',
        href: 'https://jumpcloud.com/privacy/',
      },
      {
        label: 'Trust',
        href: 'https://jumpcloud.com/trust/',
      },
      {
        label: 'Legal',
        href: 'https://jumpcloud.com/legal/',
      },
      {
        label: 'Security',
        href: 'https://jumpcloud.com/security/',
      },
      {
        label: 'GDPR',
        href: 'https://jumpcloud.com/gdpr/',
      },
    ],
  }),

  computed: {
    ...mapState(['cookiesAccepted', 'isMobileScreen']),
  },

};
</script>

<style module>
@value (max-width-small, max-width-medium) from '~css/breakpoints.css';
@value (maxSignupPageWidth) from '~css/breakpoints.css';

.footer {
  background: var(--jcWhite50);
  font-size: var(--jcBodySmall);
  padding: 2rem 2.5rem;
}

.condensed {
  font-size: 0.5rem;
  padding: 3rem 0 0;
}

.hasBanner {
  /* Needs to be same height as CookieBanner.vue */
  padding-bottom: 9rem;
}

.footerContent {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: maxSignupPageWidth;
  width: 100%;
}

.condensedContent {
  justify-content: start;
}

.copyrightText {
  margin: 0 0.625rem 0 0;
  margin-bottom: 10px;
}

/* stylelint-disable */
:global(.jc-link).footerLink {
  color: var(--jcGrey);
  text-decoration: none;
}
/* stylelint-enable */

.footerLinkContainer {
  margin: 0;
  padding: 0;
  text-align: right;
}

.footerLinkContainer li {
  display: inline-block;
  margin-bottom: 0.5em;
  margin-left: 1.5em;
}

.condensedLinkContainer {
  text-align: left;
}

.condensedLinkContainer li {
  margin-left: 5px;
  text-decoration: underline;
}

.footerLinkContainer a {
  color: var(--jcGrey);
  text-decoration: none;
}

.footer a:hover {
  color: var(--jcPrimary);
}

.footerContent ul {
  text-align: center;
}

@media (max-width: max-width-medium) {
  .footer {
    margin-top: 0;
    padding: 0.625rem 2.5rem 2rem;
    text-align: center;
  }

  .footerLinkContainer li {
    margin-bottom: 0;
  }

  .footerLinkContainer li:not(:first-child) {
    margin-left: 1rem;
  }
}
</style>
